(function () {
  'use strict';
  try {
    var cfg = window.FA_BIS_CONFIG;
    if (!cfg || !cfg.storeId || !cfg.apiBase) return;
    if (!/\/products\//.test(location.pathname)) return;
    var C = cfg.copy || {};
    var SOLD_RE = /agotado|sold\s*out|no\s+disponible|épuisé|epuise|ausverkauft|uitverkocht|esaurito|esgotado/i;

    function q(sel, root) { return (root || document).querySelector(sel); }
    function meta() { try { return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || null; } catch (e) { return null; } }
    function variantId() {
      var inp = q('input[name="id"][data-pp-id]') || q('form[action*="/cart/add"] input[name="id"]');
      if (inp && inp.value) return String(inp.value);
      var m = /[?&]variant=(\d+)/.exec(location.search); return m ? m[1] : '';
    }
    function variantTitle(id) {
      var p = meta(); if (!p || !p.variants) return '';
      for (var i = 0; i < p.variants.length; i++) { var v = p.variants[i]; if (String(v.id) === String(id)) return v.public_title || v.name || ''; }
      return '';
    }
    function productId() { var p = meta(); return p && p.id ? String(p.id) : ''; }
    function productHandle() { var m = /\/products\/([^\/?#]+)/.exec(location.pathname); return m ? decodeURIComponent(m[1]) : ''; }
    function productTitle() { var og = q('meta[property="og:title"]'); return (og && og.content) || document.title || ''; }
    function imageUrl() { var og = q('meta[property="og:image"]'); return (og && og.content) || ''; }
    function isSoldOut(btn) {
      if (!btn) return false;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return true;
      return SOLD_RE.test(btn.textContent || '');
    }
    function build() {
      var wrap = document.createElement('div');
      wrap.className = 'fa-bis';
      wrap.setAttribute('data-fa-bis', '');
      wrap.style.cssText = 'margin:14px 0 4px 0;padding:14px 16px;border:1px solid #e4dfd6;background:#faf8f4;font-family:inherit;';
      wrap.innerHTML =
        '<p style="margin:0 0 8px 0;font-size:13px;line-height:1.45;color:#1c1c1c;">' + esc(C.label || '') + '</p>' +
        '<form class="fa-bis__form" novalidate style="display:flex;gap:8px;flex-wrap:wrap;">' +
          '<input type="email" name="email" autocomplete="email" required placeholder="' + esc(C.placeholder || '') + '" style="flex:1 1 180px;min-width:0;height:42px;padding:0 12px;border:1px solid #cfc8bc;background:#fff;font-size:14px;color:#1c1c1c;">' +
          '<button type="submit" style="height:42px;padding:0 18px;border:0;background:#1c1c1c;color:#fff;font-size:12px;font-weight:600;letter-spacing:1.2px;text-transform:uppercase;cursor:pointer;">' + esc(C.button || 'OK') + '</button>' +
        '</form>' +
        '<p class="fa-bis__msg" style="margin:8px 0 0 0;font-size:13px;line-height:1.4;color:#1c1c1c;display:none;"></p>';
      return wrap;
    }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    var mounted = null;
    function mount(btn) {
      if (mounted) return;
      var host = btn.closest ? (btn.closest('form') || btn.parentNode) : btn.parentNode;
      if (!host) return;
      mounted = build();
      // direct ná de (uitverkochte) koopknop, binnen dezelfde kolom
      if (btn.parentNode === host) host.insertBefore(mounted, btn.nextSibling); else host.appendChild(mounted);
      var form = q('.fa-bis__form', mounted), msg = q('.fa-bis__msg', mounted);
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var email = (q('input[name="email"]', form).value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(msg, C.invalid || 'Invalid email'); return; }
        var vid = variantId();
        var body = { storeId: cfg.storeId, email: email, variantId: vid, productId: productId(), productHandle: productHandle(),
                     productTitle: productTitle(), variantTitle: variantTitle(vid), imageUrl: imageUrl(), language: cfg.lang || (document.documentElement.lang || '') };
        var b = q('button', form); b.disabled = true;
        fetch(cfg.apiBase.replace(/\/$/, '') + '/api/storefront/back-in-stock', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), mode: 'cors', credentials: 'omit'
        }).then(function (r) { return r.ok ? r.json().catch(function () { return {}; }) : Promise.reject(r); })
          .then(function () { form.style.display = 'none'; say(msg, C.success || 'Done'); })
          .catch(function () { b.disabled = false; say(msg, C.error || 'Error'); });
      });
    }
    function say(el, t) { el.textContent = t; el.style.display = 'block'; }
    function unmount() { if (mounted && mounted.parentNode) mounted.parentNode.removeChild(mounted); mounted = null; }

    function sync() {
      var btn = q('button[data-pp-atc]') || q('form[action*="/cart/add"] button[type="submit"][name="add"]');
      if (!btn) return;
      if (isSoldOut(btn)) mount(btn); else unmount();
    }
    var t = null;
    function schedule() { clearTimeout(t); t = setTimeout(sync, 60); }
    function start() {
      sync();
      var btn = q('button[data-pp-atc]') || q('form[action*="/cart/add"] button[type="submit"][name="add"]');
      var obsTarget = btn ? (btn.closest ? (btn.closest('form') || document.body) : document.body) : document.body;
      try { new MutationObserver(schedule).observe(obsTarget, { subtree: true, childList: true, attributes: true, characterData: true }); } catch (e) {}
      document.addEventListener('change', schedule, true);
      window.addEventListener('popstate', schedule);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  } catch (e) { /* de winkel mag hier nooit iets van merken */ }
})();
